module.exports = __webpack_public_path__ + "img/TAI2002.79b4ee5b.png";